<template>
    <main class="main-content mt-0">
        <div class="page-header align-items-start pt-5 pb-11 m-3 border-radius-lg" :style="{'background-image': 'url('+require('@/assets/images/login-back.jpg')+')'}">
            <span class="mask bg-gradient-dark opacity-6"></span>
        </div>
        <div class="login-form-content m-3">
            <div class="col-sm-12 container-welcome pos-absolute w-full">
                <div class="col-lg-5 text-center mx-auto">
                    <h1 class="font-p text-white mb-2 mt-5">Welcome</h1>
                    <p class="text-white text-uppercase fs-13">modern and advanced customer interaction system</p>
                </div>
            </div>
            <div class="row mt-lg-n10 mt-md-n11 mt-n10 justify-content-center">
                <div class="col-xl-4 col-lg-5 col-md-7 col-xxl-4 mx-auto mb-5 p-lr-0-sm">
                    <div class="card pt-4 pb-4 z-index-0">
                        <div class="card-header text-center pt-4 pb-2">
                            <div class="dis-flex flex-column pb-5">
                                <div class="logo">
                                    <img class="mx-auto" src="https://topfood.lv/wp-content/uploads/2020/06/topfoodred-1.png" width="200" alt="IMG-LOGO">
                                </div>
                                <!-- <small class="text-uppercase mt-3 fs-9">Stay together</small>
                                <h5 class="font-p mt-1">Selllogix</h5> -->
                            </div>
                            <h5 class="font-p fs-17 cl-txt-dark">Sign in</h5>
                        </div>
                        <div class="card-body pt-2">
                            <form @submit.prevent="loginMeAsAdmin()">
                                <div class="mb-3 login-form-focus">
                                    <input class="form-control" type="text" placeholder="Login Name or email" v-model="$store.state.loginData.userLogin">
                                </div>
                                <div class="mb-4 login-form-focus">
                                    <input class="form-control" type="password" placeholder="Your Passowrd" v-model="$store.state.loginData.userPassword">
                                </div>
                                <input type="submit" value="SIGN IN" class="lg-btn btn-elemnt bg-gradient-info w-100 mt-5 mb-2 text-white">
                                <div class=" position-relative text-center mt-2 mb-2">
                                    <p class="text-sm font-weight-bold text-secondary text-border d-inline z-index-2 bg-white px-3">
                                    or
                                    </p>
                                </div>
                                <input type="submit" value="SIGN UP" class="lg-btn btn-elemnt bg-gradient-dark w-100 mt-2 text-white">
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </main>
</template>

<script>
export default {
    methods: {
        loginMeAsAdmin: function() {
            let thisVue = this
            if (this.$store.state.loginData.userLogin.length <= 3) {
                alert('Login must be at least 4 characters long!')
            } else if (this.$store.state.loginData.userPassword.length <= 4) {
                alert('Password must be at least 5 characters long!')
            } else if (!socket.connected) {
                socketIoAPI.onNewConnection(function(socketVar) {
                    socketVar.on("connect", () => {
                        socket.emit('adminLogin', this.$store.state.loginData.userLogin, this.$store.state.loginData.userPassword, device, checkAdminLoginResponse)
                    })
                })
            } else {
                socket.emit('adminLogin', this.$store.state.loginData.userLogin, this.$store.state.loginData.userPassword, device, checkAdminLoginResponse)
            }

            function checkAdminLoginResponse(response) {
                if (response.response.success == true) {
                    Cookies.set('adlgn_t', response.response.sessionKey, { expires: 30 })
                    thisVue.$store.state.loginData.adminLoggedIn = true
                    thisVue.$router.replace('/');
                } else {
                    console.log(response.response.error)
                    loginToast.fire({
                        icon: 'error',
                        title: response.response.error
                    })
                }
            }
        }
    }
}
</script>

<style lang="css">
    @import '@/styles/css/login.css';
</style>